<template>
  <div style="position: relative;">
    <img src="../../../../assets/images/dashboard-feature.png" alt="2.0" />
    <button
      type="button"
      class="button button--secondary button--light button--clear dashboard__header-feature-button"
    >
      Join the Countdown
      <font-awesome-icon icon="chevron-right" />
    </button>
  </div>
</template>

<script>
export default {
  name: "dashboard-overview-feature",
};
</script>

<style></style>
